<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.2929 2.29289C15.6834 1.90237 16.3166 1.90237 16.7071 2.29289L20.7071 6.29289C21.0976 6.68342 21.0976 7.31658 20.7071 7.70711L16.7071 11.7071C16.3166 12.0976 15.6834 12.0976 15.2929 11.7071C14.9024 11.3166 14.9024 10.6834 15.2929 10.2929L17.5858 8H8C7.44772 8 7 7.55228 7 7C7 6.44772 7.44772 6 8 6H17.5858L15.2929 3.70711C14.9024 3.31658 14.9024 2.68342 15.2929 2.29289ZM8.70711 12.2929C9.09763 12.6834 9.09763 13.3166 8.70711 13.7071L6.41421 16H16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H6.41421L8.70711 20.2929C9.09763 20.6834 9.09763 21.3166 8.70711 21.7071C8.31658 22.0976 7.68342 22.0976 7.29289 21.7071L3.29289 17.7071C2.90237 17.3166 2.90237 16.6834 3.29289 16.2929L7.29289 12.2929C7.68342 11.9024 8.31658 11.9024 8.70711 12.2929Z"
      />
  </svg>

</template>

<script lang="ts">
export default {
  name: "IconSwitchHorizontal",
  props: ["height", "width"],
}
</script>
